/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { patchExternalReferenceNumberBundle } from '../fn/external/patch-external-reference-number-bundle';
import { PatchExternalReferenceNumberBundle$Params } from '../fn/external/patch-external-reference-number-bundle';
import { patchExternalReferenceNumberTour } from '../fn/external/patch-external-reference-number-tour';
import { PatchExternalReferenceNumberTour$Params } from '../fn/external/patch-external-reference-number-tour';

@Injectable({ providedIn: 'root' })
export class ExternalService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `patchExternalReferenceNumberBundle()` */
  static readonly PatchExternalReferenceNumberBundlePath = '/external/delivery-note-bundles/{deliveryNoteBundleKey}/reference-number';

  /**
   * Update the reference number of a delivery note bundle.
   *
   * This will overwrite all of the existing reference numbers on the
   * delivery notes linked to this bundle. Use the
   * 'carrierAccessToken' if the bundle is in status
   * 'open'. This makes it possible to update the reference number before
   * the checkout has been finished. Use the 'accessToken' if the
   * bundle is in status 'sent'.
   * The 'carrierAccessToken' is generated when creating the
   * signature pad for checkout. The 'accessToken' is generated
   * when finishing the checkout of the delivery note bundle.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchExternalReferenceNumberBundle()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchExternalReferenceNumberBundle$Response(params: PatchExternalReferenceNumberBundle$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return patchExternalReferenceNumberBundle(this.http, this.rootUrl, params, context);
  }

  /**
   * Update the reference number of a delivery note bundle.
   *
   * This will overwrite all of the existing reference numbers on the
   * delivery notes linked to this bundle. Use the
   * 'carrierAccessToken' if the bundle is in status
   * 'open'. This makes it possible to update the reference number before
   * the checkout has been finished. Use the 'accessToken' if the
   * bundle is in status 'sent'.
   * The 'carrierAccessToken' is generated when creating the
   * signature pad for checkout. The 'accessToken' is generated
   * when finishing the checkout of the delivery note bundle.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchExternalReferenceNumberBundle$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchExternalReferenceNumberBundle(params: PatchExternalReferenceNumberBundle$Params, context?: HttpContext): Observable<void> {
    return this.patchExternalReferenceNumberBundle$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `patchExternalReferenceNumberTour()` */
  static readonly PatchExternalReferenceNumberTourPath = '/external/tours/{tourKey}/reference-number';

  /**
   * Update the reference number of a tour.
   *
   * This will overwrite all of the existing reference numbers on the
   * delivery notes linked to this tour. You need to pass the
   * 'accessToken' as query parameter. The 'accessToken' is generated
   * when finishing the checkout of the tour.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchExternalReferenceNumberTour()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchExternalReferenceNumberTour$Response(params: PatchExternalReferenceNumberTour$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return patchExternalReferenceNumberTour(this.http, this.rootUrl, params, context);
  }

  /**
   * Update the reference number of a tour.
   *
   * This will overwrite all of the existing reference numbers on the
   * delivery notes linked to this tour. You need to pass the
   * 'accessToken' as query parameter. The 'accessToken' is generated
   * when finishing the checkout of the tour.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchExternalReferenceNumberTour$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchExternalReferenceNumberTour(params: PatchExternalReferenceNumberTour$Params, context?: HttpContext): Observable<void> {
    return this.patchExternalReferenceNumberTour$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
